export const getStartOfDayTime = (time: number, daysToAdd = 0) => {
  const date = new Date(time ?? Date.now());
  date.setDate(date.getDate() + daysToAdd);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
};

// Same day as getStartOfDayTime but at midnight UTC: the BE reads availability startDate as a UTC date,
// so the Italian midnight (22:00/23:00 UTC) would become the previous day
export const getStartOfDayUtcTime = (time: number, daysToAdd = 0) => {
  const date = new Date(getStartOfDayTime(time, daysToAdd));
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
};

export const getDayTitle = (timestamp: number, shortFormat = false) => {
  const todayMs = getStartOfDayTime(Date.now());
  const tomorrowMs = getStartOfDayTime(Date.now(), 1);
  const date = new Date(timestamp);

  const isToday = timestamp === todayMs;
  const isTomorrow = timestamp === tomorrowMs;

  if (isToday) {
    return shortFormat ? 'Oggi' : `Oggi ${date.toLocaleDateString('it', { day: 'numeric', month: 'long' })}`;
  }
  if (isTomorrow) {
    return shortFormat ? 'Domani' : `Domani ${date.toLocaleDateString('it', { day: 'numeric', month: 'long' })}`;
  }

  return shortFormat
    ? date.toLocaleDateString('it', { day: 'numeric', month: 'short' })
    : date.toLocaleDateString('it', { weekday: 'long', day: 'numeric', month: 'long' });
};
